<template>
  <aside class="c-areaInfo">
    <h2>{{ info.heading }}のエリア情報</h2>
    <div class="c-areaInfo__iconBox" @click="openAreaInfo">
      <img v-if="!isAreaInfoOpen" src="@/assets/images/icon-plus.png" alt="" />
      <img v-else src="@/assets/images/icon-minus.png" alt="" />
    </div>
    <p
      class="c-areaInfo--body"
      :class="{ 'c-areaInfo--body--full': isAreaInfoOpen }"
    >
      {{ info.content }}
    </p>
    <p class="c-areaInfo--origin">情報提供元：{{ info.origin }}</p>
  </aside>
</template>

<script>
export default {
  name: 'SearchAreaInfo',
  props: ['info'],
  data() {
    return {
      isAreaInfoOpen: false,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    openAreaInfo() {
      this.isAreaInfoOpen = !this.isAreaInfoOpen;
    },
  },
};
</script>

<style scoped lang="scss">
* {
  font-size: 14px;
}
@media screen and (max-width: 999px) {
  // 地図表記なし
}
@media screen and (min-width: 1000px) {
  // 地図表記あり
}

.c-areaInfo {
  position: relative;
  margin: 20px 40px;
  border: 1px solid #efefef;
  background-color: #fff;
  border-radius: 18px;
  padding: 20px;
  h2 {
    margin: 0 auto;
    margin-bottom: 12px;
    color: #e83532;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
  }
  &__iconBox {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
    width: 18px;
    height: 18px;

    img {
      width: 18px;
      height: 18px;
    }
  }
  &--body {
    font-size: 12px;
    line-height: 2em;
    color: #707070;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;

    &--full {
      -webkit-line-clamp: unset;
    }
  }
  &--origin {
    margin-top: 25px;
    text-align: right;
    font-size: 13px;
    color: #707070;
  }
}
@media screen and (max-width: 999px) {
  .c-areaInfo {
    &--body {
      -webkit-line-clamp: 2;

      &--full {
        -webkit-line-clamp: unset;
      }
    }
  }
}
</style>
